import { defineMessages } from 'react-intl';

export const messages: {
	childLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	optionDropdownNoOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	optionDropdownSelect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	childLabel: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.cascading-select-input.edit.child-label',
		description: 'Label for the cascading select input child field, for accessibility',
		defaultMessage: '{label} child',
	},
	optionDropdownNoOptions: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.cascading-select-input.edit.option-dropdown-no-options',
		defaultMessage: 'No options',
		description: 'Placeholder text in dropdown when there are no options.',
	},
	optionDropdownSelect: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.cascading-select-input.edit.option-dropdown-select',
		defaultMessage: 'Select...',
		description: 'Placeholder text in dropdown waiting for the user to select something.',
	},
});
